import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'
import _ from 'lodash'

const initialContract = () => {
  return {
    id: null,
    name: '',
    division: 3,
    mail_domain: '',
    pos_flag: 3,
    contract_limit_flag: 1, // 自社商品制限
    history_publish_setting_flag: 1, // 履歴共有フラグ
    reservation_publish_setting_flag: 1, // 予約共有フラグ
    group_publish_setting_flag: 1, // グループ共有フラグ
    bookmark_publish_setting_flag: 1, // ブックマーク共有フラグ
    product_attribute_use: 3, // 商品属性利用フラグ
    product_attribute_l_count: null, // 商品属性大項目許可数
    product_attribute_jan_count: null, // 商品属性JAN許可数
    user_limit: null, // ユーザー数
    product_group_limit_number: null, // 商品グループ作成可能件数
    shop_group_limit_number: null, // 店舗グループ作成可能件数
    member_group_limit_number: null, // 会員グループ作成可能件数
    product_category_group_limit_number: null, // 商品カテゴリ作成可能数
    pos_reservation_limit_number: null, // POS分析予約可能件数
    pos_history_limit_number: null, // POS分析履歴表示可能件数
    pos_analyze_limit_number: null, // POS分析回数制限数
    pos_analyze_limit_capacity: null, // POS分析従量制限数
    idpos_reservation_limit_number: null, // IDPOS分析予約可能件数
    idpos_history_limit_number: null, // IDPOS分析履歴表示可能件数
    idpos_analyze_limit_number: null, // IDPOS分析回数制限数
    idpos_analyze_limit_capacity: null, // IDPOS分析従量制限数
    active_from: '', // 反映日
    member_id_flag: 2,
    discount_flag: 1,
    gross_flag: 1,
    card_flag: 1,
    payment_flag: 1,
    product_flag: 1,
    member_attribute_flag: 1,
    decil_flag: 1,
    rank_flag: 1,
    member_address_flag: 1,
    item_category_flag: 1,
    age_gender_flag: 1,
    age_flag: 1,
    help_desk_flag: 0,
    active_to: '', // 利用終了日,
    receipt_masking_flag: 1,
    store_analysis_flag: null
  }
}
const state = {
  contract: initialContract(),
  analyze_target_list: [],
  maker_list: [],
  supplier_list: [],
  shop_area_list: [],
  product_category_list: [],
  contract_categories_0: [],
  contract_categories_1: [],
  contract_analyze_targets_0: {},
  contract_analyze_targets_1: {},
  contract_makers_0: [],
  contract_makers_1: [],
  contract_suppliers_0: [],
  contract_suppliers_1: [],
  contract_shop_areas_0: [],
  contract_shop_areas_1: [],
  message: {
    content: '',
    type: ''
  }
}

const actions = {

  async detail ({ dispatch, state, commit }, id) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    let type = 'success'
    const response = await ApiManager.request('Contract').contractDetail(id)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setContract', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  },

  async getAnalyzeTargetList ({ state, commit }) {
    // 両方
    const response = await ApiManager.request('Analyze').analyzeGet(3)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setAnalyzeTargetList', response.data.data)
    }
  },

  async getMakerList ({ state, commit }) {
    const response = await ApiManager.request('Maker').makerList(1, 100, null, null, '')
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setMakerList', response.data.data)
    }
  },

  async getAllMakerListByFreeword ({ state, commit }, freeword) {
    const response = await ApiManager.request('Maker').makerList(1, 1000, null, null, freeword)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setMakerList', response.data.data)
    }
  },

  async getSupplierList ({ state, commit }) {
    const response = await ApiManager.request('Supplier').supplierList(1, 0, null, null, '')
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setSupplierList', response.data.data)
    }
  },

  async getShopAreaList ({ state, commit }) {
    const response = await ApiManager.request('ShopArea').shopAreaList()
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setShopAreaList', response.data.data)
    }
  },

  async getProductCategoryList ({ state, commit }) {
    const response = await ApiManager.request('ProductCategory').productCategoryList()
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setProductCategoryList', response.data.data)
    }
  },

  /**
   * 新規と更新処理を行う
   */
  async updateContract ({ state, commit }, contract) {
    this.dispatch('loading/loadingPagePlus')
    let response = null
    if (contract.id) {
      _.forEach(contract, (v, k) => {
        // copy to reserved for update
        if (k.startsWith('reserved_')) {
          contract[k] = contract[k.replace('reserved_', '')]
        }
      })
      contract.reserved_reservation_date = contract.active_from
      response = await ApiManager.request('Contract').contractEdit(contract)
    } else {
      response = await ApiManager.request('Contract').contractAdd(contract)
    }
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  }

}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setMessage (state, data) {
    state.message = data
  },
  // 企業編集の場合、画面表示用の企業情報を作成する
  setContract (state, data) {
    if (!data.contract.receipt_masking_flag) {
      data.contract.receipt_masking_flag = 1
    }
    if (!data.contract.reserved_receipt_masking_flag) {
      data.contract.reserved_receipt_masking_flag = 1
    }
    state.contract = data.contract

    _.forEach(data.contract, (value, key) => {
      if (key.startsWith('reserved_')) {
        const orgKey = key.substr('reserved_'.length)
        state.contract['current_' + orgKey] = data.contract[orgKey]
        state.contract[orgKey] = data.contract.reserved_active_from ? value : data.contract[orgKey]
      }
    })
    const contractCategories0 = _.filter(data.contract_categories, c => {
      return c.contract_reservation_flag === 0
    })
    state.contract_categories_0 = contractCategories0
    const contractCategories1 = _.filter(data.contract_categories, c => {
      return c.contract_reservation_flag === 1
    })
    state.contract_categories_1 = contractCategories1

    const contractAnalyzeTargets0 = _.filter(data.contract_analyze_targets, c => {
      return c.contract_reservation_flag === 0
    })
    state.contract_analyze_targets_0 = {}
    contractAnalyzeTargets0.forEach(function (v) {
      state.contract_analyze_targets_0[v.analyze_target_code] = true
    })
    const contractAnalyzeTargets1 = _.filter(data.contract_analyze_targets, c => {
      return c.contract_reservation_flag === 1
    })
    state.contract_analyze_targets_1 = {}
    contractAnalyzeTargets1.forEach(function (v) {
      state.contract_analyze_targets_1[v.analyze_target_code] = true
    })

    const contractMakers0 = _.filter(data.contract_makers, c => {
      return c.contract_reservation_flag === 0
    })
    state.contract_makers_0 = contractMakers0
    const contractMakers1 = _.filter(data.contract_makers, c => {
      return c.contract_reservation_flag === 1
    })
    state.contract_makers_1 = contractMakers1

    const contractSuppliers0 = _.filter(data.contract_suppliers, c => {
      return c.contract_reservation_flag === 0
    })
    state.contract_suppliers_0 = contractSuppliers0
    const contractSuppliers1 = _.filter(data.contract_suppliers, c => {
      return c.contract_reservation_flag === 1
    })
    state.contract_suppliers_1 = contractSuppliers1

    const contractShopAreas0 = _.filter(data.contract_shop_areas, c => {
      return c.contract_reservation_flag === 0
    })
    state.contract_shop_areas_0 = contractShopAreas0
    const contractShopAreas1 = _.filter(data.contract_shop_areas, c => {
      return c.contract_reservation_flag === 1
    })
    state.contract_shop_areas_1 = contractShopAreas1
  },
  resetContract (state, data) {
    const contract = initialContract()
    _.each(contract, (value, key) => {
      state.contract[key] = value
    })
    state.contract_shop_areas = []
    state.contract_categories = []
    state.contract_analyze_targets = {}
    state.contract_makers = []
    state.contract_suppliers = []
  },
  setAnalyzeTargetList (state, data) {
    state.analyze_target_list = data
  },
  setMakerList (state, data) {
    state.maker_list = data
  },
  setSupplierList (state, data) {
    state.supplier_list = data
  },
  setShopAreaList (state, data) {
    state.shop_area_list = data
  },
  setProductCategoryList (state, data) {
    state.product_category_list = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
